// Path: src\Components\Popup\More\PromoCodePopup.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Popup from "../../Popup/BasePopup";
import Button from '../../CommonFields/Button';
import TextInput from '../../CommonFields/TextInput';
import { applyPromoCode } from "../../../api/promoCode.api";
import { toastSuccess, toastError } from "../../../Utilities/toast";

const PromoCodePopup = ({ isOpen, title, onClose }) => {
  const [promocode, setPromocode] = useState("");
  const [error, setError] = useState("");
  const [helperText, setHelperText] = useState("");
  const { t } = useTranslation();

  const handleInputChange = (e) => {
    let value = e.target.value.toUpperCase(); 

    value = value;

    // Allow only alphanumeric characters
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    // Ensure the value is alphanumeric and does not exceed 6 characters  sdfsdf
    if (value.length <= 10 && alphanumericRegex.test(value)) {
      setPromocode(value);
      setError("");
      setHelperText("");
    } else if (!alphanumericRegex.test(value)) {
      setError(true);
      setHelperText(t("promo_code.promo_code_should_contain_only_uppercase_letters_characters"));
    }
  };

  const handleSubmit = async () => {
    // Validation logic
    if (promocode === "") {
      setError(true);
      setHelperText(t("promo_code.please_enter_promo_code"));
    } else if (promocode?.length < 4) {
      setError(true);
      setHelperText(t("promo_code.please_enter_atleast_4_character_promo_code"));
    } else if (promocode?.length > 10) {
      setError(true);
      setHelperText(t("promo_code.please_enter_a_10_character_promo_code"));
    } else {
      // No error, proceed with the submission
      const res = await applyPromoCode(promocode);
      if (res?.success) {
        toastSuccess(t("promo_code.promocode_applied_successfully"));
        onClose();
      } else {
        toastError(res?.data?.errors?.[0]?.msg);
      }
      setError(false);
      setHelperText("");
      // Handle the invite code submission logic here
    }
  };

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
      <div className="text-input-container promo-code-popup">
        <TextInput
          labelName={t("promo_code.promo_code")}
          placeholder={t("promo_code.enter_promo_code")}
          value={promocode}
          onChange={handleInputChange}
          error={error}
        />
        <div className={`helper-text ${!helperText && 'no-error'}`}>
          {helperText}
        </div>
      </div>
      <Button text={t("promo_code.submit")} onClick={handleSubmit} />
    </Popup>
  );
};

export default PromoCodePopup;
